import { cn } from '../../lib/utils';

export type LinkVariant = 'default' | 'muted' | 'inline' | 'nav';

const variantStyles: Record<LinkVariant, string> = {
  default:
    'font-medium text-primary-600 underline-offset-4 transition-colors hover:text-primary-700 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
  muted:
    'text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
  inline:
    'text-primary-600 underline decoration-primary-600/40 underline-offset-2 transition-colors hover:text-primary-700 hover:decoration-primary-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
  nav: 'inline-flex items-center gap-1 rounded-md px-3 py-2 text-sm font-medium text-muted-foreground no-underline transition-colors hover:bg-accent/60 hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
};

export type LinkStyleProps = {
  variant?: LinkVariant;
  className?: string;
};

export function linkVariants({
  variant = 'default',
  className,
}: LinkStyleProps = {}) {
  return cn(
    variant === 'nav' ? null : 'inline',
    variantStyles[variant],
    className,
  );
}
